// birthdayEndpoints.js
import { baseApi } from '../baseApi';

export const birthdayApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getBirthdays: builder.query({
      query: (params = {}) => {
        // Dashboard mini-table passes a plain string ('NEXT_7')
        if (typeof params === 'string') {
          return {
            url: '/dashboard/birthdays',
            method: 'GET',
            params: { filterType: params },
          };
        }

        // Detail page / infinite-scroll passes a full object
        return {
          url: '/dashboard/birthdays',
          method: 'GET',
          params: {
            ...params,
            pageNumber: params.pageNumber ?? 1,
            pageSize: params.pageSize ?? 30,
          },
        };
      },
    }),

    getSalesPerformance: builder.mutation({
      query: (data) => ({
        url: '/dashboard/sales-performance',
        method: 'POST',
        body: data,
      }),
    }),

  }),
});

export const {
  useGetBirthdaysQuery,
  useLazyGetBirthdaysQuery,
  useGetSalesPerformanceMutation,
} = birthdayApi;